import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { domain, username, password, clientId },
} = checkout;

export default Yup.object().shape({
  [domain.name]: Yup.string().required(domain.errorMsg),
  [username.name]: Yup.string().required(username.errorMsg),
  [password.name]: Yup.string().required(password.errorMsg),
  [clientId.name]: Yup.string().required(clientId.errorMsg),
});
